import { createIconComponent } from './helpers';
import { faClock } from '@fortawesome/free-solid-svg-icons'

export const ClockIcon = createIconComponent(faClock);
